// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 1,
		title: '无粉乳胶指套',
		category: '适用于电子、光学、航空航天、精密机械、美容、印刷等行业。',
		img: require('@/assets/images/t1.jpg'),
		img2: require('@/assets/images/t5.jpg'),
		link: 'https://item.taobao.com/item.htm?spm=a2oq0.12575281.0.0.25911deb651vht&ft=t&id=555850298397',
	},
	{
		id: 2,
		title: '防静电指套',
		category: '采用泰国天然浓缩乳胶和食品级精细化工原料生产，RoHS2.0合格，可提供检测报告。',
		img: require('@/assets/images/t2.jpg'),
		img2: require('@/assets/images/t6.jpg'),
		link: 'https://item.taobao.com/item.htm?spm=a2oq0.12575281.0.0.25911deb651vht&ft=t&id=555816350175'
	},
	{
		id: 3,
		title: '无卤指套',
		category: '引用新型材料，在国内率先开发的不含氟、氯、溴、碘等卤族元素的乳胶指套，由天然乳胶制成，同时不含有重金属离子、塑化剂，符合欧盟标准。',
		img: require('@/assets/images/t3.jpg'),
		img2: require('@/assets/images/t7.jpg'),
		link: 'https://item.taobao.com/item.htm?spm=a2oq0.12575281.0.0.25911deb651vht&ft=t&id=544263021911'
	},
	{
		id: 4,
		title: '无卤长效防静电指套',
		category: '采用无卤素环保材料制成，抗静电有效期12个月，不依赖湿度且长效稳定，为精密电子元件提供安全、洁净的静电防护。',
		img: require('@/assets/images/t4.jpg'),
		img2: require('@/assets/images/t8.jpg'),
		link: 'https://item.taobao.com/item.htm?id=1035255662619&mi_id=0000ReE7XnCjJa8hOxkoRU4T1Z_PhnOhRndizeFYN_6o1gQ&spm=a21xtw.29178619.0.0&xxc=shop&skuId=6051346616783',
	}
];

export default projects;
